// extracted by mini-css-extract-plugin
module.exports = {"tabs":"ProfileTabMenu_tabs__N2F51","tab":"ProfileTabMenu_tab__ylTks","selectedTab":"ProfileTabMenu_selectedTab__vswpA"};